import {
  PDF_TIME_SUMMARY_REPORT,
  PDF_DAY_SUMMARY_REPORT,
  PDF_OPERATOR_DETAIL_REPORT,
  PDF_OPERATOR_SUMMARY_REPORT,
  PDF_PART_DETAIL_REPORT,
  PDF_PART_SUMMARY_REPORT,
  PDF_PERFORMANCE_REPORT,
  EXCEL_MULTIDAY_DETAIL_REPORT,
  PDF_JOB_CARD,
  EXCEL_TIME_SUMMARY_REPORT,
  EXCEL_PNL_SUMMARY_REPORT,
} from "../../constants/apis";
import {
  getUrl,
  replaceMultiple,
  getDownloadFileName,
  getDownloadExcelFileName,
} from "../../utilities/helpers";

const download = (response, fileName) => {
  try {
    const blob = new Blob([response], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the PDF:", error);
  }
};

const downloadExcel = (response, fileName) => {
  try {
    const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the Excel file:", error);
  }
};
export const fetchTimeSummaryReportPdf =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(PDF_TIME_SUMMARY_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(result, getDownloadFileName("time-summary-report", filters))
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchDaySummaryReportPdf =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(PDF_DAY_SUMMARY_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(result, getDownloadFileName("day-summary-report", filters))
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchJobCard =
  (company_uuid,filters) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrl = replaceMultiple(PDF_JOB_CARD, {"{{company_uuid}}":company_uuid})
    const url = getUrl(finalUrl, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(result, getDownloadFileName("job-card", filters))
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchOperatorDetailReportPdf =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(PDF_OPERATOR_DETAIL_REPORT, {
        "{{uuid}}": uuid,
      }),
      filters
    );
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(result, getDownloadFileName("operator-detail-report", filters))
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchOperatorSummaryReportPdf =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(PDF_OPERATOR_SUMMARY_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(
          result,
          getDownloadFileName("operator-summary-report", filters)
        )
      )
      .catch((error) => {
        throw error;
      });
  };

  export const fetchMultiydayreport =
  (filters, type) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(EXCEL_MULTIDAY_DETAIL_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        downloadExcel(
          result,
          getDownloadExcelFileName(type, filters)
        )
      )
      .catch((error) => {
        throw error;
      });
  };
  
 export const fetchTimeExcelreport =
  (filters, type) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(EXCEL_TIME_SUMMARY_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        downloadExcel(
          result,
          getDownloadExcelFileName(type, filters)
        )
      )
      .catch((error) => {
        throw error;
      });
  };

 export const fetchPnlExcelreport =
  (filters, type) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(EXCEL_PNL_SUMMARY_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        downloadExcel(
          result,
          getDownloadExcelFileName(type, filters)
        )
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchPartDetailReportPdf =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(PDF_PART_DETAIL_REPORT, {
        "{{uuid}}": uuid,
      }),
      filters
    );
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(result, getDownloadFileName("part-detail-report", filters))
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchPartSummaryReportPdf =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(PDF_PART_SUMMARY_REPORT, filters);
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) =>
        download(result, getDownloadFileName("part-summary-report", filters))
      )
      .catch((error) => {
        throw error;
      });
  };

export const fetchPerformanceReportPdf =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(PDF_PERFORMANCE_REPORT, {
        "{{uuid}}": uuid,
      }),
      filters
    );
    return apiReport
      .get(url, { responseType: "blob" })
      .then((result) => download(result, getDownloadFileName("performance-report", filters)))
      .catch((error) => {
        throw error;
      });
  };
